import { useEffect, useState } from "react";

import useLocalization from "../../hooks/useLocalization";
import useData from "../../hooks/useData";

import { Box } from "@mui/material";

import AutoComplete from "../elements/AutoComplete";
import Input from "../elements/Input";
import EditorToolbar from "./EditorToolbar";
import Loading from "../ui/Loading";

const territorySchema = {
  _id: null,
  name: null,
  name_fr: null,
  userId: null,
};

const TerritoryEditor = ({
  projectId,
  syndicationId,
  territoryId,
  onSave,
  onDelete,
  message,
}) => {
  const { getLabel } = useLocalization();
  const { getFromServer, updateRecord, executeAction } = useData();

  const [territory, setTerritory] = useState({ ...territorySchema });
  const [users, setUsers] = useState(null);

  useEffect(() => {
    setTerritory({ ...territorySchema });
    getData();
  }, [territoryId]);

  const getData = async () => {
    const userList = await getFromServer({
      entityName: "User",
      filter: {
        isActive: true,
      },
    });

    setUsers(userList);

    if (!territoryId) return;

    const data = await getFromServer({
      entityName: "Territory",
      id: territoryId,
    });
    setTerritory(data);
  };

  const handleChange = (field, newValue) => {
    setTerritory((current) => {
      return { ...current, [field]: newValue };
    });
  };

  const handleSave = async () => {
    const data = { ...territory, projectId, syndicationId };

    let results = null;

    if (data?.id) {
      results = await executeAction({
        entityName: "Territory",
        action: "saveAndReassign",
        data,
        displayMessage: true,
      });
    } else {
      results = await updateRecord("Territory", data);
    }

    if (results?.isSuccessful) {
      onSave();
    }
  };

  const handleDelete = () => {
    onDelete(territory);
  };

  return (
    <Box width="100%">
      <EditorToolbar
        onSave={handleSave}
        onDelete={territoryId ? handleDelete : null}
        message={message}
      />

      {Array.isArray(users) ? (
        <Box
          display="flex"
          flexDirection="column"
          gap={1}
          padding="10px"
        >
          <Input
            id="name"
            label={getLabel("name")}
            value={territory?.name || ""}
            onChange={(newValue) => handleChange("name", newValue)}
            width="100%"
          />
          <Input
            id="name_fr"
            label={getLabel("name_fr")}
            value={territory?.name_fr || ""}
            onChange={(newValue) => handleChange("name_fr", newValue)}
            width="100%"
          />

          <Box
            sx={{ display: "flex", justifyContent: "space-between" }}
            gap={1}
          >
            <Input
              id="region"
              label={getLabel("region")}
              value={territory?.region || ""}
              onChange={(newValue) => handleChange("region", newValue)}
            />
            <Input
              id="area"
              label={getLabel("area")}
              value={territory?.area || ""}
              onChange={(newValue) => handleChange("area", newValue)}
            />
          </Box>

          <AutoComplete
            id="reps"
            label="rep"
            value={territory?.userId || null}
            items={users}
            onChange={(newValue) => handleChange("userId", newValue)}
            width="100%"
          />
          <Input
            id="hourlyRate"
            label={getLabel("hourlyRate")}
            value={territory?.hourlyRate || ""}
            onChange={(newValue) => handleChange("hourlyRate", newValue)}
          />
        </Box>
      ) : (
        <Loading />
      )}
    </Box>
  );
};

export default TerritoryEditor;
